import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useGetBuildingsByIdOwnerQuery, usePutSpacesByIdOwnerMutation } from '@client/api';
import { PageDetailContent } from '@client/toolkit';

import { PageContentAnimation } from '../../../../../components';
import { CompaniesCard } from '../../../components/companies-card/companies-card.component';

export function BuildingCompaniesOwnersRoute() {
  const { buildingId } = useParams<{ buildingId: string }>();
  const { t: tType } = useTranslation('type');
  const { t: tNotification } = useTranslation('notification');

  const {
    data: buildingOwners,
    isFetching,
    refetch,
  } = useGetBuildingsByIdOwnerQuery({ id: buildingId ?? '' }, { skip: !buildingId });

  const [putOwners] = usePutSpacesByIdOwnerMutation();

  return (
    <PageDetailContent align="left">
      <PageContentAnimation>
        <CompaniesCard
          role={'Owner'}
          isLoading={isFetching}
          companies={buildingOwners ?? []}
          buildingId={buildingId}
          title={tType(`RelationshipType.Owner`, { context: 'plural' })}
          onEdit={(data) =>
            putOwners({ id: buildingId ?? '', body: { owners: data.map((company) => company.id) } })
              .unwrap()
              .then(() => {
                refetch();
                toast.success(tNotification('editing.fulfilled'));
              })
          }
        />
      </PageContentAnimation>
    </PageDetailContent>
  );
}
